import React from 'react';
import bem from 'utils/bem';
import FeedbackFormBlock from 'forms/forms/FeedbackForm/FeedbackFormBlock';
import WhiteBox from 'components/WhiteBox';

import './index.sass';

const { block } = bem('contacts-feedback-form-block');
const ContactsFeedbackFormBlock = () => {
    return (
        <div className={ block() }>
            <WhiteBox bg>
                <FeedbackFormBlock
                    title={ 'Есть вопросы?\nПишите нам, и мы с радостью вам ответим!' }
                    text={ 'Если вам нужна помощь в подборе специалиста, или это ваш первый опыт в психотерапии, и вы хотите задать какие-то вопросы, — мы будем рады помочь' }
                />
            </WhiteBox>
        </div>
    )
}

export default ContactsFeedbackFormBlock;
